import LazyLoading from './common/lazyLoading';
import LoadPurchase from './common/loadPurchase.js';
import LoadSpeechSearch from './components/loadSpeechSearch.js';
import CartDrawer from './common/cartDrawer';
import CouponModal from './common/couponModal';
import Footer from './common/footer';
import Header from './common/header';
import Webforms from './common/webforms';
import Price from './components/price/price.js';
import { NewsletterComponent } from './components/vndaComponents.js';
import { setSearch } from './components/utilities';
import BackToTop from './common/backToTop';
import setTopBar from './components/topBar';
import ProductBlockByColors from './components/productBlockByColors';

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cOlist - Soluções de vendas online e Serviços de E-commerce',
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  Header.init();
  setTopBar();
  Price.init();
  ProductBlockByColors.init();
  LazyLoading.init();
  LoadPurchase.init();
  LoadSpeechSearch.init()
  CartDrawer.init();
  Footer.init();
  CouponModal.init();
  Webforms.init();
  NewsletterComponent.init();
  setSearch();
  BackToTop.init();
});
